import { createSelector } from '@reduxjs/toolkit';
import {
  selectProjectsDetails,
  selectOptionsPercentTotal,
  selectOptionsPlusTotal,
} from '../project/projectSelectros';

export const selectHubspot = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.hubspot || {}
);

export const selectHubspotCalculationParams = createSelector(
  selectHubspot,
  projectOther => projectOther.calculationOptions || {}
);

export const selectHubspotPagesTotal = () => {
  return {
    discount: 0,
    totalPricePages: 0
  };
};

export const selectHubspotOptionsTotal = createSelector(
  selectHubspotPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectHubspotTotal = createSelector(
  selectHubspotPagesTotal,
  selectHubspotOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectHubspotTotalForAsap = createSelector(
    selectHubspotTotal,
    (totalPrice) => {
      return totalPrice / 2;
    }
);

export const selectHubspotEta = () => ({
  etaText: '',
  etaIsExists: false
});

export const selectHubspotDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});

